import script from "./Manage.vue?vue&type=script&setup=true&lang=js"
export * from "./Manage.vue?vue&type=script&setup=true&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=5b6108b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6108b6"]])

export default __exports__